import styled, { useTheme } from 'styled-components';
import { Flex, Text } from 'dash-ui';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RoutesPath } from 'flow-components/routes/routes';

const FooterStyle = styled(Flex)<{
  variation: 'light' | 'dark';
  withSidebar?: boolean;
}>`
  min-height: 56px;
  position: relative;
  bottom: 0;
  background-color: ${({ theme, variation }) =>
    variation === 'light' ? theme.colors.b10 : theme.colors.n90};
  color: ${({ theme, variation }) =>
    variation === 'light' ? theme.colors.n70 : theme.colors.white};
  flex-direction: row;
  ${({ variation, theme }) =>
    variation === 'light' &&
    `
      border-top: 1px solid ${theme.colors.b20};
    `}

  @media ${({ theme }) => theme.devices.tablet} {
    position: relative;
    ${({ withSidebar }) => withSidebar && `margin-bottom: 56px`};
  }

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    min-height: 104px;
    ${({ withSidebar }) => withSidebar && `margin-bottom: 56px`};
    position: relative;
  }
`;

const Devider = styled(Flex)<{ variation: 'light' | 'dark' }>`
  border-bottom: 1px solid
    ${({ variation, theme }) =>
      variation === 'light' ? theme.colors.n70 : theme.colors.white};
  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 6px;
  }
`;

const LinkCenterContainer = styled(Flex)`
  @media ${({ theme }) => theme.devices.mobile} {
    margin-bottom: ${({ theme }) => theme.space * 4}px;
    margin-left: ${({ theme }) => theme.space * 4}px;
    margin-right: unset;
  }

  margin-right: ${({ theme }) => theme.space * 8}px;
  margin-left: ${({ theme }) => theme.space * 8}px;
`;

const Footer = ({
  variation = 'light',
  withSidebar = true,
}: {
  variation: 'light' | 'dark';
  withSidebar?: boolean;
}) => {
  const { t } = useTranslation(['pages']);
  const theme = useTheme();
  const color = variation === 'light' ? theme.colors.b50 : theme.colors.white;
  return (
    <FooterStyle
      variation={variation}
      flex={1}
      w="100%"
      justifyContent="center"
      alignItems="center"
      withSidebar={withSidebar}
    >
      <Flex>
        <Flex flexDirection="column">
          <Link to={RoutesPath.TermConditions} target="_blank">
            <Text as="span" color={color}>
              {t('pages:footer:termsLabel')}
            </Text>
          </Link>
          <Devider w="100%" variation={variation} />
        </Flex>
        <LinkCenterContainer flexDirection="column">
          <Link to={RoutesPath.PrivacyPolicy} target="_blank">
            <Text as="span" color={color}>
              {t('pages:footer:policyLabel')}
            </Text>
          </Link>
          <Devider w="100%" variation={variation} />
        </LinkCenterContainer>
      </Flex>
      <Flex>
        <Text color={color}>{t('pages:footer:rightLabel')}</Text>
      </Flex>
    </FooterStyle>
  );
};

export default Footer;
